export { default } from '@mui/private-theming/ThemeProvider';